import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../../services/language.service';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class AppFooterComponent {

  activeLanguage = 'german';
  activePage = '';
  navbarLinks: any = {
      'german': {
          imprint: 'Impressum',
          tcs: 'AGB',
          ds: 'Datenschutz',
          disclaimer: ''
      },
      'english': {
        imprint: 'Imprint',
        tcs: 'T&Cs',
        ds: 'Data Security',
        disclaimer: 'German only:'
      }
  };

  constructor(private ls: LanguageService, private router: Router) {
      ls.getLanguage().subscribe(val => this.activeLanguage = val);
      router.events.subscribe(event => {
          if (event instanceof NavigationEnd) {
              this.activePage = event.url;
          }
      });
  }


}



// WEBPACK FOOTER //
// ./src/app/components/footer/footer.component.ts